// 客服工作台路由：自包含命名空间，仅通过根 router/index.js 注入。
import CsLayout from './layouts/CsLayout.vue'
import Login from './views/Login.vue'
import SelectionOrders from './views/SelectionOrders.vue'

const routes = [
  {
    path: '/cs/login',
    name: 'cs-login',
    component: Login,
    meta: { public: true, title: '客服登录' }
  },
  {
    path: '/cs',
    component: CsLayout,
    redirect: '/cs/selection-orders',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'selection-orders',
        name: 'cs-selection-orders',
        component: SelectionOrders,
        meta: { title: '自动择日提交信息' }
      }
    ]
  }
]

export default routes
